export function qs(params?: object): string {
  if (params === undefined) {
    return ''
  }
  const query = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value != null) {
      query.set(key, String(value))
    }
  }
  const str = query.toString()
  return str ? `?${str}` : ''
}

export interface QueryResult<T> {
  data: T | null
  loading: boolean
  lastFetchedAt: number | null
  refetch: () => void
  /**
   * Last fetch failure, null once a refetch succeeds. Optional because the
   * pre-TanStack hooks had no error channel — consumers that want to surface
   * failures (e.g. the dashboard's PROD-992 toast) read it explicitly.
   */
  error?: Error | null
}

export interface MutationResult<TData, TArgs extends unknown[]> {
  perform: (...args: TArgs) => Promise<TData>
  loading: boolean
}
